import { Container, Typography } from '@mui/material';
import { InstitutionFormFragment } from 'modules/Admin/Institutions/fragments/InstitutionFormFragment';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'services';
import { UIBreadcrumb, UILink } from 'shared/components';
import TitleWithSubtitle from 'shared/components/TitleWithSubtitle';
import { InstitutionModel } from 'types/models';
import { UrlParams } from 'types/services';

export function HospitalInstitutionCreateUpdatePage() {
  const params = useParams() as UrlParams;
  const id = params?.id;

  const [institution] = useQuery<InstitutionModel, InstitutionModel>(
    `/institution/${id}`,
    {
      fetchOnInitialize: !!+id
    }
  );

  return (
    <Container maxWidth={'lg'}>
      <UIBreadcrumb>
        <UILink to={'/dashboard'}> Dashboard </UILink>
        <UILink to={'/instituicao'}> Instituições </UILink>
        <Typography color={'primary'}>
          {id
            ? 'Editar Instituição Hospitalar'
            : 'Cadastrar Instituição Hospitalar'}
        </Typography>
      </UIBreadcrumb>
      <TitleWithSubtitle
        title="Instituição Hospitalar"
        subtitle="Preencha as informações da instituição"
      />
      <InstitutionFormFragment
        type="hospital"
        id={+id}
        institution={institution}
      />
    </Container>
  );
}
